import { c as _c } from "react/compiler-runtime";
import { AboveValueConfigKind, BelowValueConfigKind, BetweenValueConfigKind, UserConversationLengthValueConfig } from '@/api/generated/model';
import { useState } from 'react';
import { translate } from '@/utils/translations';
import { nullableNumberToString } from '@/utils/numbers.util';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/comps/primitives/select';
import { Button } from '@/comps/primitives/button';
import { Input } from '@/comps/primitives/input';
type ValueKind = BetweenValueConfigKind | AboveValueConfigKind | BelowValueConfigKind;
type IProps = {
  onApply: (e: UserConversationLengthValueConfig) => void;
};
export const UserConversationLengthForm = t0 => {
  const $ = _c(37);
  const {
    onApply
  } = t0;
  const [valueKind, setValueKind] = useState("above");
  const [firstNumber, setFirstNumber] = useState(5);
  const [secondNumber, setSecondNumber] = useState(10);
  let t1;
  if ($[0] !== firstNumber || $[1] !== onApply || $[2] !== secondNumber || $[3] !== valueKind) {
    t1 = () => {
      if (valueKind === AboveValueConfigKind.above || valueKind === BelowValueConfigKind.below) {
        onApply({
          interactions_count: {
            kind: valueKind,
            value: firstNumber,
            offset: new Date().getTimezoneOffset()
          }
        });
      } else {
        if (valueKind === BetweenValueConfigKind.between) {
          onApply({
            interactions_count: {
              kind: "between",
              value: [firstNumber, secondNumber],
              offset: new Date().getTimezoneOffset()
            }
          });
        }
      }
    };
    $[0] = firstNumber;
    $[1] = onApply;
    $[2] = secondNumber;
    $[3] = valueKind;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const apply = t1;
  const t2 = valueKind === BetweenValueConfigKind.between ? "Users who have had conversations" : "Users who have had conversations with";
  let t3;
  if ($[5] !== t2) {
    t3 = <p className="text-sm">{t2}</p>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = value => setValueKind(value as ValueKind);
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== valueKind) {
    t5 = translate("value_config_kind", valueKind);
    $[8] = valueKind;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <SelectTrigger className="w-auto"><SelectValue>{t5}</SelectValue></SelectTrigger>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SelectItem value={AboveValueConfigKind.above}>{translate("value_config_kind", AboveValueConfigKind.above)}</SelectItem>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SelectItem value={BelowValueConfigKind.below}>{translate("value_config_kind", BelowValueConfigKind.below)}</SelectItem>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SelectContent>{t7}{t8}<SelectItem value={BetweenValueConfigKind.between}>{translate("value_config_kind", BetweenValueConfigKind.between)}</SelectItem></SelectContent>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== valueKind) {
    t10 = <Select value={valueKind} onValueChange={t4}>{t6}{t9}</Select>;
    $[15] = t6;
    $[16] = valueKind;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== firstNumber) {
    t11 = nullableNumberToString(firstNumber);
    $[18] = firstNumber;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = e => setFirstNumber(parseInt(e.target.value));
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11) {
    t13 = <Input value={t11} type="number" className="h-8 w-12 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" onChange={t12} />;
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== secondNumber || $[24] !== valueKind) {
    t14 = valueKind === BetweenValueConfigKind.between && <><p className="text-sm">and</p><Input value={nullableNumberToString(secondNumber)} type="number" className="h-8 w-12 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none" onChange={e_0 => setSecondNumber(parseInt(e_0.target.value))} /></>;
    $[23] = secondNumber;
    $[24] = valueKind;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <p className="text-sm">turns</p>;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t10 || $[28] !== t13 || $[29] !== t14) {
    t16 = <div className="flex items-center gap-2">{t10}{t13}{t14}{t15}</div>;
    $[27] = t10;
    $[28] = t13;
    $[29] = t14;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== apply) {
    t17 = <Button className="mt-1" size="sm" onClick={apply}>Apply</Button>;
    $[31] = apply;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t16 || $[34] !== t17 || $[35] !== t3) {
    t18 = <div className="flex flex-col gap-2">{t3}{t16}{t17}</div>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t3;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
};